// extracted by mini-css-extract-plugin
module.exports = {"icon":"__global___icon"};